// test873
(873 && 0);
